<template>
  <page-list
    :list="list"
    :columns="filteredColumns"
    :single-actions="cloudEnv === 'service' ? singleActions : []"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter } from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

function getServiceListOptions (vm) {
  const env = vm.cloudEnv || 'service'
  return {
    id: vm.id,
    resource: `${env}s`,
    apiVersion: 'v1',
    getParams: vm.getParam,
    filterOptions: {
      name: getNameFilter(),
    },
  }
}

export default {
  name: 'NoticeList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
    },
    cloudEnv: String,
  },
  data () {
    return {
      list: this.$list.createList(this, getServiceListOptions(this)),
    }
  },
  computed: {
    filteredColumns () {
      return this.columns.filter(column => {
        if (this.cloudEnv === 'service') {
          return column.field !== 'agent_type' && column.field !== 'host_type' && column.field !== 'brand'
        }
        if (this.cloudEnv === 'baremetalagent') {
          return column.field !== 'type' && column.field !== 'host_type' && column.field !== 'brand' && column.field !== 'enabled'
        }
        if (this.cloudEnv === 'host') {
          return column.field !== 'agent_type' && column.field !== 'type'
        }
        return true
      })
    },
  },
  watch: {
    cloudEnv (val, oldVal) {
      if (val === oldVal) return
      const env = val || 'service'
      const resource = `${env}s`
      this.list.resource = resource
      this.list.manager = new this.$Manager(resource, 'v1')
      // 清空筛选并重拉第一页，避免整表替换 list 引用导致子树重挂载
      this.list.changeFilter({})
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...this.getParams,
        scope: this.$store.getters.scope,
        details: true,
      }
      if (this.cloudEnv === 'host') {
        ret.provider = 'OneCloud'
        ret.host_type = ['kvm', 'container']
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ServiceSidePage', {
        id: row.id,
        resource: async () => {
          if (this.cloudEnv === 'service') {
            return new this.$Manager(`services/${row.id}/config`, 'v1').list()
          }
          // 非控制服务无 config 接口：侧滑 mixin 需要 { data } 形态，由 list 行数据写入 data.data
          return { data: {} }
        },
        apiVersion: 'v1',
        getParams: this.getParams,
      }, {
        list: this.list,
        cloudEnv: this.cloudEnv,
      })
    },
  },
}
</script>
